import { createLoader, loader, revalidate } from "@rangojs/router";

export const CartLoader = createLoader(async (ctx) => {
  "use server";
  const session = ctx.get("session")!;
  const basketId = session.get("basketId");
  if (!basketId) return { cart: Promise.resolve(null) };

  const commerce = ctx.get("userCommerce")!;

  // Return cart as a promise so it streams without blocking page render
  const cart = commerce.shopperBaskets
    .getBasket({
      parameters: { basketId, currency: undefined, locale: undefined } as any,
    })
    .catch(() => {
      // Basket may have expired or been deleted
      session.delete("basketId");
      return null;
    });

  return { cart };
});

export const AttachCartLoader = () => [
  loader(CartLoader, () => [
    revalidate(({ actionId, stale }) => {
      return (actionId?.includes("cart") || stale) ?? false;
    }),
  ]),
];
